// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import LoadScript from 'components/load-script/load-script'

class FbCustomerChat extends React.Component {
	componentDidMount() {
		window.fbAsyncInit = function() {
			FB.init( {
				xfbml: true,
				version: 'v11.0'
			} )
		}
	}

	render() {
		const { page, location } = this.props
		let style = {}

		if ( ! safeSiteData.fb_customer_chat_page_id ) {
			return null
		}

		const allowedSlugs = [
			'contact-us',
			'volunteer',
			'donate'
		]

		if ( location && '/' == location.pathname ) {

		} else if ( ! page || ! allowedSlugs.includes( page.slug ) ) {
			style.display = 'none'
		}

		return (
			<div style={ style }>
				<LoadScript
					src={ `https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js` }
				/>

				<div id="fb-root"></div>

				<div
					className="fb-customerchat"
					page_id={ safeSiteData.fb_customer_chat_page_id }
					greeting_dialog_display="icon"
				/>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( FbCustomerChat )



// WEBPACK FOOTER //
// ./components/facebook/facebook-customer-chat.jsx